const COUNTABLE_KIND = {
  'sms_blast': 'textableTargets',
  'sms_survey': 'textableTargets',
  'sms_conversations': 'textableTargets',
  'whatsapp': 'whatsappableTargets',
  'phone': 'callableTargets',
  'email': 'emailableTargets'
}


// This should be kept in sync with app/services/core/calculate_draft_campaign_target_count_service.rb
// which is used by the backend to calculate the target count for a draft campaign
export default function useCountTargets() {
  return useSel(s => {
    const { search, campaignType, textMessageBlast, emailBlast, subscriptionTopic, settings } = s.campaign
    const entity = textMessageBlast || emailBlast

    const kind = entity?.kind === 'whatsapp' ? 'whatsapp' : campaignType
    const isConstitutional = s.campaign.emailBlast && s.campaign.emailBlast.isConstitutional
    if (isConstitutional) {
      var possibleTargetCount = search?.stats?.['constitutionalEmailableTargets'] || 0
    } else {
      const column = COUNTABLE_KIND[kind]
      if (!column || !search?.stats) return { targetCount: null, possibleTargetCount: null }

      const topics = search.stats[column]
      if (!topics) return { targetCount: null, possibleTargetCount: null }

      var possibleTargetCount = topics[_.camelCase(subscriptionTopic)] || 0
    }

    var targetCount = possibleTargetCount

    const { limitTotalMessages, maxTotalMessages, testMode, testSizePerVariant } = settings
    if (limitTotalMessages === 'on' && maxTotalMessages) {
      targetCount = Math.min(parseInt(maxTotalMessages), targetCount)
    }

    if (testMode === 'ab') {
      if (isNaN(parseInt(testSizePerVariant))){
        return { targetCount: 0, possibleTargetCount, invalidCountMessage: "You need to set a test size in settings to be able to see a count and send" }
      }
      const testSendSize = parseInt(testSizePerVariant) * entity.contentVariants.length
      targetCount = Math.min(testSendSize, targetCount)
    }

    return { targetCount, possibleTargetCount }
  })
};
